import { createSelector } from '@ngrx/store';

export const selectProductosPedidosState = (state: { productosPedidos: any }) =>
  state.productosPedidos;

export const selectProductosPedidosPendientes = createSelector(
  selectProductosPedidosState,
  prodcutosPedidos => prodcutosPedidos.pendientes,
);
